/**
 * @callback PersonalizationCondition
 * @param {import('./store.js').PersonalizationStore} [store] - Optional personalization store
 * @returns {boolean}
 */

/**
 * @type {Record<string, PersonalizationCondition>}
 */
const conditions = {
  isEnglishLang: (store) => {
    const lang = store?.get("lang");
    return lang === "en";
  },
  isPDUser: (store) => {
    const isPDUser = store?.get("isPDUser");
    return isPDUser === true;
  },
  isPDUserExcludingEmployees: (store) => {
    const isPDUser = store?.get("isPDUser");

    const segmentData = store?.get("segmentData");
    const userEmail = segmentData?.email || "";
    const isNotPDEmployee =
      userEmail.length == 0 || !userEmail.includes("@pagerduty.com");

    return Boolean(isPDUser && isNotPDEmployee);
  },
  inEurope: (store) => {
    const cfData = store?.get("cfData");
    return cfData?.continent === "EU";
  },
};

/**
 * @param {string} name
 * @returns {PersonalizationCondition}
 */
export default function getCondition(name) {
  return conditions[name] || (() => true);
}
